export const GFUNC_DOMAIN="https://europe-west1-clouditbase.cloudfunctions.net/api"
//export const GFUNC_DOMAIN="http://192.168.1.101:5000/clauditbase/europe-west1/api"
//export const GFUNC_DOMAIN="/api"